import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';
import 'moment-duration-format';

import _ from "lodash";
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import FormComponent from "../FormComponent";

//- graphics
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from "../../containers/AuthUser";
import FormTextArea from "../form/FormTextArea";
import UserPicker from "../advancedForm/UserPicker";
import FormDatePicker from "../form/FormDatePicker";
import FormTimePicker from "../form/FormTimePicker";

import TimeClockContainer from '../../containers/TimeClock/TimeClock';
import {post} from "../../modules/utility";
import ErrorIcon from '@material-ui/icons/Error';
import TimeClockLocationSelect from '../advancedForm/TimeClockLocationSelect';

function styles () {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle : {
			fontSize : 20,
			borderBottom : '1px solid #eee',
			paddingBottom : 5,
			marginBottom : 10,
			fontWeight : 300,
			display : 'flex',
			justifyContent : 'space-between',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems : 'end'
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton : {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize : 16,
			marginTop : 20,
			color : 'white',
			marginRight : 10,
		},

		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		},
		pleaseSelect : {
			fontStyle : 'italic',
			color : '#777',
		},
		currentShiftContainer : {
			border : `1px solid #eee`,
			backgroundColor : '#fcfcfc',
			padding : `20px 20px`,
			margin : '20px 0px',
			borderRadius : 5,
		},
		currentShiftTitle : {
			display : 'flex',
			alignItems : 'center',
			fontSize : 17,
		},
		errorIcon : {
			color:'#F44336',
			marginRight : 10,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		currentLabel : {
			color : '#666',
			marginLeft : 30,
			marginRight : 5
		},
		currentValue : {
			fontWeight : 500,
		},
	};
}

class ClockOutEmployeeDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving : false,
			savingSuccessful : false,
			clockOutDate : moment().format('YYYY-MM-DD'),
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.shiftForUserId !== this.state.shiftForUserId) {
			this.fetchCurrentShift();
		}

		const { timeClockShift } = this.props;
		if (timeClockShift && prevProps.timeClockShift !== timeClockShift) {
			return this.setState({
				shiftForUserId : timeClockShift.shiftForUserId,
				currentTimeClockShift : timeClockShift,
			});
		}
	}

	fetchCurrentShift = () => {
		this.setState({ fetchingShifts: true, });

		const { shiftForUserId } = this.state;
		post({
			method: 'timeClockShift.manager.getLastShiftInfo',
			params: {
				shiftForUserIds : [shiftForUserId],
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						fetchingShifts: false,
						searchErrors: err,
						currentTimeClockShift : null,
					});
				}

				const currentTimeClockShift = _.get(r, 'collections.timeClockShiftCollection.0');
				return this.setState({
					fetchingShifts: false,
					currentTimeClockShift
				});
			}
		});
	};

	handleSubmit = () => {
		const {timeClockShiftManagerClockOut, showErrors} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({path, label}) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			return showErrors(_.values(formFieldError));
		}


		const {
			currentTimeClockShift,
			clockOutDate,
			clockOutTime,
			note,
			timeClockLocationId,
		} = this.state;

		if (!currentTimeClockShift) {
			return showErrors(['Select an employee that is currently clocked in on a shift']);
		}

		const { timeClockShiftId} = currentTimeClockShift;

		const clockOutMoment = moment(clockOutDate);
		const timeMoment = moment(clockOutTime);
		clockOutMoment.hour(timeMoment.hour()).minute(timeMoment.minute());

		const params = {
			timeClockShiftId,
			clockOutDateTime : clockOutMoment.utc().format('YYYY-MM-DD HH:mm:ss'),
			note,
			timeClockLocationId,
		};

		this.setState({ isSaving: true, savingSuccessful : false });
		timeClockShiftManagerClockOut({
			params,
			callback: (err, apiResult) => {
				if (err) {
					this.setState({ isSaving : false });
					showErrors(err);
					return;
				}
				_.delay(() => {
					this.props.afterSave({ apiResult });
					this.handleClose();
				}, 400);
			}
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful : false,
			isSaving : false,
		});
		this.props.onClose();
	};

	render() {
		const {
			open,
			classes,
			myCanModifyUserIds,
		} = this.props;

		const isRequired = true;
		const { isSaving, savingSuccessful, currentTimeClockShift } = this.state;

		let shiftIsBad = true;
		if (currentTimeClockShift && !currentTimeClockShift.clockOutDateTime) {
			shiftIsBad = false;
		}

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper : classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							Manually Clock Out Employee
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={this.handleClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{marginTop : 0, marginBottom : 0}}>
							<UserPicker
								{...this.setForm('shiftForUserId', 'Employee to clock out', isRequired)}
								helpText={"Only showing employees you have permission for"}
								userIdsToShow={myCanModifyUserIds}
								isPortal={true}
							/>

							{this.renderShowCurrentShift()}

							<FormDatePicker
								{...this.setForm('clockOutDate', 'Clock out date', isRequired)}
								gridProps={{ md : 6}}
							/>

							<FormTimePicker
								{...this.setForm('clockOutTime', 'Clock out time', isRequired)}
								gridProps={{ md : 6}}
							/>

							<TimeClockLocationSelect
								{...this.setForm('timeClockLocationId', 'Location of Clock Out', isRequired)}
							/>

							<FormTextArea
								{...this.setForm('note', 'Reason for manager clock out', isRequired)}
								rows={2}
							/>

							<Grid item md={12} style={{display : 'flex', alignItems : 'baseline'}}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleSubmit}
									disabled={isSaving || savingSuccessful || shiftIsBad}
								>
									Clock Out Employee
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{verticalAlign : 'middle'}} />
										<span style={{paddingLeft: 10}}>Saving...</span>
									</div>
								</Zoom>

								<Zoom in={savingSuccessful} style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon}/>
										<span style={{paddingLeft: 10}}>Employee clocked in successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}
	renderShowCurrentShift = () => {

		const { classes } = this.props;
		const { shiftForUserId, fetchingShifts, currentTimeClockShift } = this.state;

		if (!shiftForUserId) {
			return (
				<Grid item xs={12} >
					<div className={classes.currentShiftContainer}>
						<div className={classes.pleaseSelect}>
							Pick an employee to show their current clocked in shift.
						</div>
					</div>
				</Grid>
			);
		}

		if (fetchingShifts) {
			return (
				<Grid item xs={12} >
					<div className={classes.currentShiftContainer}>
						<div className={classes.currentShiftTitle}>
							<CircularProgress style={{verticalAlign : 'middle'}} />
							<span style={{paddingLeft: 10}}>Fetching current shift...</span>
						</div>
					</div>
				</Grid>
			);
		}

		if (!currentTimeClockShift) {
			return (<Grid item xs={12} >
				<div className={classes.currentShiftContainer}>
					<div className={classes.currentShiftTitle}>
						<ErrorIcon className={classes.errorIcon}/>
						No record of this employee ever clocking in.
					</div>
				</div>
			</Grid>);
		}

		const { clockInDateTime, clockOutDateTime} = currentTimeClockShift;
		if (clockOutDateTime) {
			return (<Grid item xs={12} >
				<div className={classes.currentShiftContainer}>
					<div className={classes.currentShiftTitle}>
						<ErrorIcon className={classes.errorIcon}/>
						Employee is not currently clocked in.
					</div>
				</div>
			</Grid>);
		}

		const clockInMoment = moment(clockInDateTime);
		const duration = moment.duration(moment().diff(clockInMoment));

		return (<Grid item xs={12} >
			<div className={classes.currentShiftContainer}>
				<div className={classes.currentShiftTitle}>
					<div className={classes.greenCheckedIcon}/> Employee is currently logged in
				</div>
				<div style={{marginTop : 7, paddingTop : 7, borderTop : '1px solid #ddd' }}>
					<span className={classes.currentLabel}>Clock in date / time</span>
					<span className={classes.currentValue}>{clockInMoment.format('M/D h:mm a')}</span>
				</div>
				<div style={{marginTop : 5}}>
					<span className={classes.currentLabel}>Current duration</span>
					<span className={classes.currentValue}>
						{moment.duration(duration).format('d [days], h [hrs], m [min]')}
					</span>
				</div>
			</div>
		</Grid>);
	}
}

ClockOutEmployeeDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func,
	myCanModifyUserIds : PropTypes.array,
	timeClockShiftManagerClockOut : PropTypes.func.isRequired,
	afterSave : PropTypes.func.isRequired,
	timeClockShift : PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockContainer,
])(ClockOutEmployeeDialog);
